// removed by extract-text-webpack-plugin
module.exports = {"foldBox":"styles__foldBox__1xMQa","heading":"styles__heading__3ULkA","subHeading":"styles__subHeading__2GibY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupFold/styles.scss
// module id = 415
// module chunks = 0